import axios from 'axios'

function errorsOrDefault(error, defaultErrorMessage = 'Request failed for an unknown reason') {
	return error?.response?.data?.messages || error?.response?.data?.error
		? { message: error.response.data.error, code: error.response.data.code }
			? { message: error.response.data.error, code: error.response.data.code }
			: { message: error.response.data.error, code: error.response.data.code }
		: [defaultErrorMessage]
}

export const updateUser = token => {
	const currentUser = JSON.parse(localStorage.getItem('user') ?? '{}')

	let newUser = {}
	try {
		// Parse token to extract user data
		newUser = JSON.parse(atob(token.split('.')[1]))
	} catch (err) {
		console.log(err)
	}

	localStorage.setItem('user', JSON.stringify({ ...currentUser, ...newUser, jwt: token }))
	// Update common Authorization header value
	axios.defaults.headers.common.Authorization = getAuthToken()
}

const logOutUser = () => {
	localStorage.removeItem('user')
}

export const getAuthToken = () => {
	return JSON.parse(localStorage.getItem('user') || '{}')?.jwt
}

const request = async function (req, defaultMsg) {
	try {
		const response = await axios(req)
		return response
	} catch (error) {
		if (error.response.status === 401 || (error.response.status === 422 && error.response.data?.messageId === 31)) {
			// Log user out and redirect to login
			logOutUser()
			return (window.location.href = `${process.env.REACT_APP_ID_UI}?k=${process.env.REACT_APP_CLIENT_API_KEY}`)
		}

		return {
			error: errorsOrDefault(error, defaultMsg),
			status: error?.response?.status,
		}
	}
}

class Request {
	static get({ params = {}, url, headers = {}, responseType, defaultMsg } = {}) {
		return request(
			{
				method: 'GET',
				url,
				params,
				headers,
				responseType,
			},
			defaultMsg,
		)
	}

	static post({ data = {}, params = {}, url, headers = {}, responseType, defaultMsg } = {}) {
		return request(
			{
				method: 'POST',
				url,
				data,
				params,
				headers,
				responseType,
			},
			defaultMsg,
		)
	}

	static put({ data = {}, params = {}, url, headers = {}, responseType, defaultMsg } = {}) {
		return request(
			{
				method: 'PUT',
				url,
				data,
				params,
				headers,
				responseType,
			},
			defaultMsg,
		)
	}

	static patch({ data = {}, params = {}, url, headers = {}, responseType, defaultMsg } = {}) {
		return request(
			{
				method: 'PATCH',
				url,
				data,
				params,
				headers,
				responseType,
			},
			defaultMsg,
		)
	}

	static delete({ params = {}, url, headers = {}, responseType, defaultMsg } = {}) {
		return request(
			{
				method: 'DELETE',
				url,
				params,
				headers,
				responseType,
			},
			defaultMsg,
		)
	}
}

export default Request
